export interface IKrUpdate {
  title: string;
  confidence: number;
  value: number;
  comment?: string;
}

export interface ITodoReflection {
  teamId: string;
  dueDate: string;
  id: string;
  questions: ReflectionQuestion<ReflectionQuestionType>[];
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ReflectionDTO {}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Reflection {}

export enum ReflectionQuestionType {
  textArea = "textArea",
  checkList = "checkList",
  radio = "radio",
  list = "list",
  yesOrNo = "yesOrNo",
  krUpdates = "krUpdates",
}

export interface IReflectionQuestionOption {
  orderId: number;
  value: string;
}

type ReflectionQuestionTypeToDataMap = {
  textArea: null;
  checkList: {
    data?: {
      options: IReflectionQuestionOption[];
    };
  };
  radio: {
    data?: {
      options: IReflectionQuestionOption[];
    };
  };
  list: {
    data?: {
      options: IReflectionQuestionOption[];
    };
  };
  yesOrNo: null;
  krUpdates: null;
};

type ReflectionQuestionTypeToData = {
  [QuestionType in ReflectionQuestionType]: ReflectionQuestionTypeToDataMap[ReflectionQuestionType];
};

export type ReflectionQuestionData<T extends ReflectionQuestionType> = {
  [Key in keyof ReflectionQuestionTypeToData[T]]: ReflectionQuestionTypeToData[T][Key];
};

export type ReflectionQuestion<T extends ReflectionQuestionType> = {
  id: string;
  text: string;
  type: T;
  createdAt: string;
  isEnabled: boolean;
  isDefault: boolean;
  // will be implemented in the next iteration
  // orderId: number;
} & ReflectionQuestionData<T>;

export type ReflectionScheduleCadence = "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday";

export interface IReflectionSchedule {
  cadence: ReflectionScheduleCadence;
  isPaused: boolean;
}

export interface IReflection {
  id: string;
  accountId: string;
  teamId: string;
  templateId: string;
  questions: ReflectionQuestion<ReflectionQuestionType>[];
  createdAt: string;
  updatedAt?: string;
  schedule: IReflectionSchedule;
  isEnabled: boolean;
}

export interface IReflectionUpdateAnswerBase {
  questionId: string;
  // max=200
  question: string;
  // max=500
  answer: string;
}

export interface IReflectionUpdateAnswer extends IReflectionUpdateAnswerBase {
  id: string;
  createdAt: string;
  updatedAt?: string;
}

export interface IReflectionUpdate {
  id: string;
  reflectionId: string;
  userId: string;
  teamId: string;
  accountId: string;
  createdAt: string;
  updatedAt?: string;
  answers: IReflectionUpdateAnswer[];
}
